import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import * as _ from "lodash";
import NibbleInput from "../../../components/Fields/NibbleInput";
import {
  getSelectsInstallation,
  getUsers,
  resourcesInstallationTypes,
} from "../../../helpers/backend_helper";

const General = ({ validation }) => {
  const [types, setTypes] = useState([]);
  const [users, setUsers] = useState([]);
  const [estados, setEstados] = useState([]);
  const [equipaments, setEquipaments] = useState([]);

  const savePosition = (position) => {
    validation.setFieldValue(
      "ubicacion_gps",
      `${position.coords.latitude},${position.coords.longitude}`
    );
  };
  
  useEffect(() => {
    let params = { params: { select: true } };

    getUsers(params).then((response) => {
      setUsers(response.data);
    });

    resourcesInstallationTypes("get", params).then((response) => {
      setTypes(response.data);
    });

    getSelectsInstallation(params).then((response) => {
      setEquipaments(response.equipaments);
      setEstados(response.estados);
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(savePosition);
    } else {
      console.log("La geolocalización no es compatible con este navegador.");
    }
  }, []);

  return (
    <Card className="mb-4 installation">
      <CardHeader>
        <h5 className="m-0">Datos Generales</h5>
      </CardHeader>
      <CardBody>
        <div className="row">
          <NibbleInput
            md={4}
            label="Tipo de Instalación:"
            fieldName="tipo_id"
            fieldType="select"
            selectItems={types}
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Equipo a instalar:"
            fieldName="equipamiento_id"
            fieldType="select"
            selectItems={equipaments}
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Empresa:"
            fieldName="empresa"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Colonia:"
            fieldName="colonia"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Estado:"
            fieldName="estado_id"
            fieldType="select"
            selectItems={estados}
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Municipio:"
            fieldName="municipio"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Domicilio:"
            fieldName="domicilio"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Ubicación GPS:"
            fieldName="ubicacion_gps"
            fieldType="text"
            validation={validation}
            readOnly
          />
          <NibbleInput
            md={4}
            label="Marca:"
            fieldName="marca"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Modelo:"
            fieldName="modelo"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Color:"
            fieldName="color"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Unidad:"
            fieldName="unidad"
            fieldType="number"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Año:"
            fieldName="anio"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Placas:"
            fieldName="placas"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Concesión:"
            fieldName="concesion"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Tipo bloqueo:"
            fieldName="tipo_bloqueo"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="No ruta:"
            fieldName="no_ruta"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Imei:"
            fieldName="imei"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Serie vehicular:"
            fieldName="serie"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="No motor:"
            fieldName="no_motor"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Celular:"
            fieldName="celular"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={4}
            label="Chip:"
            fieldName="chip"
            fieldType="text"
            validation={validation}
          />
          <NibbleInput
            md={6}
            label="Técnicos:"
            fieldName="tecnicos"
            fieldType="select"
            selectItems={users}
            validation={validation}
            selectIsMulti
          />
          <NibbleInput
            md={12}
            label="Observaciones del estado del vehiculo:"
            fieldName="edo"
            fieldType="textarea"
            validation={validation}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default General;
